export default __webpack_public_path__ + "static/property-description-graph-d-318bde74ee2718a293b71ad79064c18b.jpg";